module.exports = __webpack_public_path__ + "img/BO.8088bf95.png";